if (!customElements.get('xtrem-product-media')) {
  customElements.define('xtrem-product-media', class extends HTMLElement {
    connectedCallback() {
      const viewport = this.querySelector('.xp-media__viewport');
      const toggle = this.querySelector('.xp-media__toggle');
      if (!viewport || !toggle || this.controller) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false;
      let hovered = false;
      let pressed = false;
      let paused = false;

      const update = () => {
        const focused = viewport.matches(':focus-visible') || viewport.querySelector(':focus-visible');
        this.classList.toggle('is-keyboard-focused', Boolean(focused));
        this.classList.toggle('is-paused', paused);
        this.classList.toggle('is-running', visible && !document.hidden && !reducedMotion.matches && !focused && !hovered && !pressed && !paused);
        toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
      };

      toggle.addEventListener('click', () => { paused = !paused; update(); }, options);
      viewport.addEventListener('focusin', update, options);
      viewport.addEventListener('focusout', () => queueMicrotask(update), options);
      viewport.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') { hovered = true; update(); }
      }, options);
      viewport.addEventListener('pointerleave', () => { hovered = false; update(); }, options);
      viewport.addEventListener('pointerdown', () => { pressed = true; update(); }, options);
      document.addEventListener('pointerup', () => { pressed = false; update(); }, options);
      document.addEventListener('pointercancel', () => { pressed = false; update(); }, options);
      document.addEventListener('visibilitychange', update, options);
      reducedMotion.addEventListener('change', update, options);
      this.observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; update(); });
      this.observer.observe(this);
      this.classList.add('is-ready');
      toggle.hidden = false;
      update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
      this.classList.remove('is-ready', 'is-running', 'is-keyboard-focused', 'is-paused');
    }
  });
}
